<cap-button styleClass="secondary"
            capButtonLoading
            [submitting]="loading$ | async"
            [disabled]="loading$ | async"
            [label]="action?.label"
            [icon]="(loading$ | async) ? 'fas fa-spinner fa-spin' : action?.icon"
            (onClick)="handleAction(action)">
</cap-button>
